import React from 'react';
import CroopLaunch from './components/CroopLaunch';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import './components/CroopBrand.css';
import DanceVideoSegmenter from './components/DanceVideoSegmenter';
import PaymentSuccess from './components/PaymentSuccess';
import PaymentCanceled from './components/PaymentCanceled';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ComboBuilderPrototype from './components/combo-prototype/ComboBuilderPrototype';
import LibraryPrototype from './components/library-prototype/LibraryPrototype';
import MigrationPage from './pages/MigrationPage';
import TestPage from './pages/TestPage';
import ThumbnailMigrationUtility from './pages/ThumbnailMigration';
import { getCurrentPlatformCapabilities } from './platform/platformCapabilities';

function App() {
  const platformCapabilities = getCurrentPlatformCapabilities();
  const params = new URLSearchParams(window.location.search);
  const hasShareOrLegacySession = platformCapabilities.canExposeSharing && (params.has('share') || params.has('session'));

  const showTests = platformCapabilities.canAccessDevOnlyRoutes && !hasShareOrLegacySession && params.get('tests') === 'true';
  if (showTests) {
    return <TestPage />;
  }

  const showMigration = platformCapabilities.canAccessDevOnlyRoutes && !hasShareOrLegacySession && params.get('migration') === 'true';

  if (showMigration) {
    return <MigrationPage />;
  }

  const showThumbnail = platformCapabilities.canAccessDevOnlyRoutes && !hasShareOrLegacySession && params.get('thumbnail') === 'true';

  if (showThumbnail) {
    return <ThumbnailMigrationUtility />;
  }


  return (
    <BrowserRouter>
      <div className="App">
        <CroopLaunch />
        <Routes>
          <Route path="/" element={<DanceVideoSegmenter />} />
          {platformCapabilities.canAccessDevOnlyRoutes && (
            <>
              <Route path="/prototype/combo-builder" element={<ComboBuilderPrototype />} />
              <Route path="/prototype/library" element={<LibraryPrototype />} />
            </>
          )}
          {platformCapabilities.canShowPaymentUpgradeUi && (
            <>
              <Route path="/payment-success" element={<PaymentSuccess />} />
              <Route path="/payment-canceled" element={<PaymentCanceled />} />
            </>
          )}
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
